export function loadVWO() {
    if (process.env.REACT_APP_FRONT_PROD_URL === window.location.origin) {
        var link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = 'https://dev.visualwebsiteoptimizer.com';
        document.head.appendChild(link);
        var script = document.createElement('script');
        script.src = '/js/vwo.js';
        script.async = true;
        document.head.appendChild(script);
    }
}
